export default class locale {
  static sign_up(loc) {
    switch (loc) {
      case "en":
        return "Sign up for Free";
      case "ja":
        return "ユーザー登録（無料）";
      default:
        return "Sign up for Free";
    }
  }

  static login(loc) {
    switch (loc) {
      case "en":
        return "Login";
      case "ja":
        return "ログイン";
      default:
        return "Login";
    }
  }

  static logout(loc) {
    switch (loc) {
      case "en":
        return "Logout";
      case "ja":
        return "ログアウト";
      default:
        return "Logout";
    }
  }

  static register_with_email(loc) {
    switch (loc) {
      case "en":
        return "Sign up with email";
      case "ja":
        return "メールアドレスで登録";
      default:
        return "Sign up with email";
    }
  }

  static login_with_email(loc) {
    switch (loc) {
      case "en":
        return "Login with email";
      case "ja":
        return "メールアドレスでログイン";
      default:
        return "Login with email";
    }
  }

  static email(loc) {
    switch (loc) {
      case "en":
        return "Email";
      case "ja":
        return "メールアドレス";
      default:
        return "Email";
    }
  }

  static password(loc) {
    switch (loc) {
      case "en":
        return "Password (At least six characters)";
      case "ja":
        return "パスワード（６文字以上）";
      default:
        return "Password (At least six characters)";
    }
  }

  static myPage(loc) {
    switch (loc) {
      case "en":
        return "My Page";
      case "ja":
        return "マイページ";
      default:
        return "My Page";
    }
  }

  static addNode(loc) {
    switch (loc) {
      case "en":
        return "Add your node. (120-character limit)";
      case "ja":
        return "ノードの追加(120文字以内)";
      default:
        return "Add your node. (120-character limit)";
    }
  }

  static after_email_message(loc) {
    switch (loc) {
      case "en":
        return "You will receive an email with instructions for how to confirm your email address in a few minutes.";
      case "ja":
        return "2,3分後に確認用メールがご登録のアドレスに届きます。メールをご確認の上、ご登録を完了してください。";
      default:
        return "You will receive an email with instructions for how to confirm your email address in a few minutes.";
    }
  }

  static after_password_email_message(loc) {
    switch (loc) {
      case "en":
        return "You will receive an email with instructions for how to reset your password in a few minutes.";
      case "ja":
        return "数分以内にパスワードリセットメールがご登録のアドレスに届きます。メールをご確認ください。";
      default:
        return "You will receive an email with instructions for how to confirm your email address in a few minutes.";
    }
  }

  static example(loc) {
    switch (loc) {
      case "en":
        return "example )";
      case "ja":
        return "- リンク例- ";
      default:
        return "example )";
    }
  }

  static linkExample(loc) {
    switch (loc) {
      case "en":
        return "Here's [a link](http://www.example.com/)! ";
      case "ja":
        return "これは [Google](http://www.google.com/) へのリンクです。";
      default:
        return "Here's [a link](http://www.example.com/)! ";
    }
  }

  static needToSignupBeforeAdd(loc) {
    switch (loc) {
      case "en":
        return "Please sign up and add your node. It's super easy :)";
      case "ja":
        return "ユーザー登録（無料）をしてノードを追加してください。登録はとっても簡単です。";
      default:
        return "Please sign up and add your node. It's super easy :)";
    }
  }

  static needToSignupBeforeLike(loc) {
    switch (loc) {
      case "en":
        return "Please sign up and like the Node. It's super easy :)";
      case "ja":
        return "ユーザー登録（無料）の後、ノードをlikeしてください。登録はとっても簡単です。";
      default:
        return "Please sign up and like the Node. It's super easy :)";
    }
  }

  static signup_with_facebook(loc) {
    switch (loc) {
      case "en":
        return "Signup with Facebook account";
      case "ja":
        return "Facebookアカウントで登録";
    }
  }

  static signup_with_twitter(loc) {
    switch (loc) {
      case "en":
        return "Signup with Twitter account";
      case "ja":
        return "Twitterアカウントで登録";
    }
  }

  static signup_with_email(loc) {
    switch (loc) {
      case "en":
        return "Signup with E-mail";
      case "ja":
        return "E-mailで登録";
    }
  }

  static forgotYourPW(loc) {
    switch (loc) {
      case "en":
        return "Forgot your password?";
      case "ja":
        return "パスワード忘れた？";
      default:
        return "Forgot your password?";
    }
  }

  static registered_email(loc) {
    switch (loc) {
      case "en":
        return "Registered Email";
      case "ja":
        return "登録メールアドレス";
      default:
        return "Registered Email";
    }
  }

  static reset_password(loc) {
    switch (loc) {
      case "en":
        return "Send Password Reset Email";
      case "ja":
        return "パスワード再設定メールの送信";
      default:
        return "Send Password Reset Email";
    }
  }


  static please_set_password(loc) {
    switch (loc) {
      case "en":
        return "Please set your new Password";
      case "ja":
        return "パスワードを再設定してください";
      default:
        return "Please set your new Password";
    }
  }

  static send(loc) {
    switch (loc) {
      case "en":
        return "Send";
      case "ja":
        return "送信";
      default:
        return "Send";
    }
  }

  static about_this_site(loc) {
    switch (loc) {
      case "en":
        return "About this site";
      case "ja":
        return "このサイトについて";
      default:
        return "About this site";
    }
  }

  static top_node(loc) {
    switch (loc) {
      case "en":
        return "Top Node";
      case "ja":
        return "トップノード";
      default:
        return "Top Node";
    }
  }

  static created_by(loc) {
    switch (loc) {
      case "en":
        return "Created By";
      case "ja":
        return "作った人";
      default:
        return "Created By";
    }
  }

  static update(loc) {
    switch (loc) {
      case "en":
        return "Update";
      case "ja":
        return "更新";
      default:
        return "Update";
    }
  }

  static delete(loc) {
    switch (loc) {
      case "en":
        return "Delete";
      case "ja":
        return "削除";
      default:
        return "Delete";
    }
  }

  static delete_message(loc) {
    switch (loc) {
      case "en":
        return "Are you sure you want to delete this node?";
      case "ja":
        return "このノードを削除しますか？";
      default:
        return "Are you sure you want to delete this node?";
    }
  }

  static cannot_delete_message(loc) {
    switch (loc) {
      case "en":
        return "This Node cannot be deleted since it has child nodes. You can only edit the Node.";
      case "ja":
        return "このノードは子ノードがあるため削除できません。編集のみ可能です。";
      default:
        return "This Node cannot be deleted since it has child nodes. You can only edit the Node.";
    }
  }

  static cancel(loc) {
    switch (loc) {
      case "en":
        return "Cancel";
      case "ja":
        return "キャンセル";
      default:
        return "Cancel";
    }
  }

  static is_invalid(loc) {
    switch (loc) {
      case "en":
        return "is invalid";
      case "ja":
        return "が無効です";
      default:
        return "is invalid";
    }
  }

  static have_an_account(loc) {
    switch (loc) {
      case "en":
        return "Have an account? ";
      case "ja":
        return "既にユーザー登録済み？ ";
      default:
        return "Have an account? ";
    }
  }

  static help(loc) {
    switch (loc) {
      case "en":
        return "Help";
      case "ja":
        return "使い方";
      default:
        return "Help";
    }
  }

  static user_ranking(loc) {
    switch (loc) {
      case "en":
        return "User Ranking";
      case "ja":
        return "ホットユーザーランキング";
      default:
        return "User Ranking";
    }
  }

  static add_node(loc) {
    switch (loc) {
      case "en":
        return "Add Node";
      case "ja":
        return "ノードの追加";
      default:
        return "Add Node";
    }
  }

  static next_nodes(loc) {
    switch (loc) {
      case "en":
        return "Next Nodes";
      case "ja":
        return "の以降のノード";
      default:
        return "Next Nodes";
    }
  }

  static languages(loc) {
    switch (loc) {
      case "en":
        return "Programming Language";
      case "ja":
        return "プログラミング言語";
      default:
        return "Programming Language";
    }
  }

  static java_link(loc) {
    switch (loc) {
      case "en":
        return process.env.REACT_APP_NODE_JAVA_EN;
      case "ja":
        return process.env.REACT_APP_NODE_JAVA_JA;
    }
  }

  static php_link(loc) {
    switch (loc) {
      case "en":
        return process.env.REACT_APP_NODE_PHP_EN;
      case "ja":
        return process.env.REACT_APP_NODE_PHP_JA;
    }
  }

  static cpp_link(loc) {
    switch (loc) {
      case "en":
        return process.env.REACT_APP_NODE_CPP_EN;
      case "ja":
        return process.env.REACT_APP_NODE_CPP_JA;
    }
  }
  static swift_link(loc) {
    switch (loc) {
      case "en":
        return process.env.REACT_APP_NODE_SWIFT_EN;
      case "ja":
        return process.env.REACT_APP_NODE_SWIFT_JA;
    }
  }

  static scala_link(loc) {
    switch (loc) {
      case "en":
        return process.env.REACT_APP_NODE_SCALA_EN;
      case "ja":
        return process.env.REACT_APP_NODE_SCALA_JA;
    }
  }

  static mobile_alert(loc) {
    switch (loc) {
      case "en":
        return 'node-node-node has only PC version.'
      case "ja":
        return 'node-node-nodeはPCに対応したサービスです。'
    }
  }

  static mobile_alert2(loc) {
    switch (loc) {
      case "en":
        return 'You can enjoy full service with your PC.'
      case "ja":
        return 'PCでのご利用をおすすめいたします'
    }
  }

  static useful(loc) {
    switch (loc) {
      case "en":
        return 'Useful'
      case "ja":
        return '役に立つ'
    }
  }

  static funny(loc) {
    switch (loc) {
      case "en":
        return 'Funny'
      case "ja":
        return '面白い'
    }
  }

  static cool(loc) {
    switch (loc) {
      case "en":
        return '???'
      case "ja":
        return 'なにこれ？'
    }
  }

  static money(loc) {
    switch (loc) {
      case "en":
        return 'Money'
      case "ja":
        return 'お金が儲かる'
    }
  }

  static like(loc) {
    switch (loc) {
      case "en":
        return 'Like'
      case "ja":
        return 'いいね'
    }
  }

  static title_one(loc) {
    switch (loc) {
      case "en":
        return "IT knowledge into graph network "
      case "ja":
        return 'エンジニアの集合知を図解 '
    }
  }

  static title_two(loc) {
    switch (loc) {
      case "en":
        return ''
      case "ja":
        return ' するSNS'
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/locale.js